/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Box, Typography } from "@material-ui/core";
import { DsmEmptyState, DsmGrid } from "@dsm-dcs/design-system-react";
import CompositeDatasetListTableV2 from "./CompositeDatasetListTableV2";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import { prodProcessDatasetsPageStyles } from "../../../ThemeProvider";

interface ArchiveSectionProps {
  prodProcess: any;
  archivedBaselines: any[];
  // When true, the farm's data was ingested via the partner API (read-only in UI).
  partnerReadOnly?: boolean;
  customerID: string;
  farmID: string;
  processID: string;
  selectedFarmName: string;
  openDataset: (
    datasetType: string,
    baselineId: string,
    formType: string,
  ) => void;
  makeDeleteHandler: (type: string) => (itemName: string) => void;
  handleDuplicate: (datasetType: string, item: any) => void;
}

const ArchiveSection = ({
  prodProcess,
  archivedBaselines,
  partnerReadOnly = false,
  customerID,
  farmID,
  processID,
  selectedFarmName,
  openDataset,
  makeDeleteHandler,
  handleDuplicate,
}: ArchiveSectionProps) => {
  const intl = useIntl();
  const pageClasses = prodProcessDatasetsPageStyles();

  return (
    <>
      <DsmGrid
        className={`${pageClasses.sectionGrid} ${pageClasses.archiveGridTemplate}`}
      >
        <Box className={pageClasses.alignSelfStart}>
          <Typography
            variant="h6"
            className={pageClasses.datasetsTableIntroTitle}
          >
            {intl.formatMessage({ id: "SUSTELL.BASELINE.ARCHIVE" })}
          </Typography>

          <Typography
            variant="body1"
            className={pageClasses.bodyTextNeutralDarkerWithMargin}
          >
            {intl.formatMessage({ id: "SUSTELL.BASELINE.ARCHIVE.DESCRITPION" })}
          </Typography>
        </Box>
      </DsmGrid>

      {archivedBaselines?.length > 0 ? (
        <CompositeDatasetListTableV2
          datasets={archivedBaselines}
          customerID={customerID}
          farmID={farmID}
          processID={prodProcess?.id}
          farmName={selectedFarmName}
          processName={prodProcess?.name}
          animalType={prodProcess.animalType}
          archive
          benchmark={false}
          partnerReadOnly={partnerReadOnly}
          openDataset={openDataset}
          deleteDataset={makeDeleteHandler("baseline")}
          duplicateDataset={handleDuplicate}
        />
      ) : (
        <DsmEmptyState
          icon="general/search-md"
          header={intl.formatMessage({ id: "GENERAL.NO_DATA" })}
          className={pageClasses.sectionEmptyState}
        />
      )}
    </>
  );
};

export default ArchiveSection;
